module.exports = __webpack_public_path__ + "img/success.d2d586f3.svg";